
import { useDebounce } from '@uidotdev/usehooks'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { useTranslations } from '@/hooks/useTranslations'
import { Fragment, useCallback, useEffect, useState } from 'react'
import { Loader } from '@/components/common/Loader'
// import { useConfirmDeleteUserModal, useConfirmInviteModal, useInvitedWarningModal } from '@/components/common/Modals'
import { toast } from '@/components/common/Toast'
import { Button, LinkButton, SelectContent, Select, SelectItem, SelectTrigger, SelectValue, Input } from '@/components/ui'
import { UserDropdown, UserOrganizationStatus, UserStatus } from '@/constants/user'
// import {
//   useDeleteUserOrganization,
//   useGetOrganizationUserList,
//   useResendInviteUserOrganization,
// } from '@/modules/user/services/user'

import { useDatatableHeaders } from './columns'
// import { useConfirmDownloadModal } from '@/components/common/Modals/ConfirmDownloadModal'
import { DateFormat, formatDate } from '@/utils/date'
import { useDataTable } from '@/hooks/useDataTable'
import { DEFAULT_PAGE_SIZE_OPTIONS } from '@/constants/datatable'
import { DataTable } from '@/components/common/DataTable/DataTable'
import { Profile, useCreateUser, useDeleteUser, useGetUserList, useUpdateUser } from '@/modules/user/services/user'
import { useGetCustomerList, useGetCustomerNoPage } from '@/modules/customer/services/customer'
import { Customer } from '@/models/customer/customer'


export const CustomerManagementList = () => {
  const t = useTranslations('admin.customer_management')
  const navigate = useNavigate()
  const search = useSearch({ strict: false }) as { tab?: string }
  const [searchTerm, setSearchTerm] = useState('')
  const [status, setStatus] = useState<string>('')
  const [tab, setTab] = useState<string>(search.tab || 'buy')
  const [paymentMethod, setPaymentMethod] = useState<string>('all')
  const [paymentStatus, setPaymentStatus] = useState<string>('all')
  const [printStatus, setPrintStatus] = useState<string>('all')
  const debouncedSearchTerms = useDebounce(search, 500)
  const [searchTerms, setSearchTerms] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const $apiDeleteUser = useDeleteUser()
  const $apiUpdateUser = useUpdateUser()

  const onClickBillDropdownEvent = useCallback(
    async (eventName: string, item: Customer) => {
      switch (eventName) {
        case UserDropdown.VIEW:
          navigate({ to: `/admin/customer/${item.id}` })
          break
        case UserDropdown.EDIT:
          navigate({ to: `/admin/customer/${item.id}/edit` })
          break
        // case UserDropdown.DELETE:
        //   await $apiDeleteUser.mutateAsync({ id: item.id });
        //   // showConfirmDeleteUserModal()
        //   break
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  const { data: customerListNoPage } = useGetCustomerNoPage()

  const { columns } = useDatatableHeaders({ search: searchTerms, onClickBillDropdownEvent })

  const { dataTableProps, state, setData, setTotalPages, setPagination } = useDataTable({
    columns,
    showPageSize: true,
    showPagination: true,
    isLoading: false,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    sorting: [
      {
        id: 'created_at',
        desc: true,
      },
    ],
  })

  const { data, isPending } = useGetCustomerList({
    page: state.pagination.page,
    pageSize: state.pagination.pageSize,
    search: searchTerms,
    status: tab,
    sort: state.sorting,
  })

  useEffect(() => {
    setSearchTerms(debouncedSearchTerms)
  }, [debouncedSearchTerms])

  useEffect(() => {

    setData(data?.data ?? [])
    setTotalPages(data?.meta?.totalPages ?? 1)
  }, [data, setData, setTotalPages])

  useEffect(() => {
    setPagination({ pageIndex: 0, pageSize: state.pagination.pageSize })
  }, [search, status])

  // const handleClickResendInvitation = async (user: any | null) => {
  //   try {
  //     setIsLoading(true)
  //     if (!user) {
  //       throw new Error('User is not found')
  //     }

  //     await $apiResendInvite.submitResend({
  //       orgId,
  //       userId: user.id,
  //     })

  //     toast.toastSuccess(<HighlightWord message={tForm('toast.resend_invitation_success', { email: user.email })} />)
  //   } catch (error: any) {
  //     console.error(error)
  //     toast.toastFailed(tForm('toast.resend_invitation_failed'))
  //   } finally {
  //     setIsLoading(false)
  //     setUserSelected(null)
  //   }
  // }

  // const handleClickDeleteUser = async (user: any | null) => {
  //   try {
  //     setIsLoading(true)
  //     if (!user) {
  //       throw new Error('User is not found')
  //     }

  //     await $apiDeleteUser.submitDelete({
  //       orgId,
  //       userId: user.id,
  //     })

  //     toast.toastSuccess(<HighlightWord message={tForm('toast.delete_success', { email: user.email })} />)
  //     refetch()
  //   } catch (error) {
  //     console.error(error)
  //     toast.toastFailed(tForm('toast.delete_failed'))
  //   } finally {
  //     setIsLoading(false)
  //     setUserSelected(null)
  //   }
  // }

  const isHasFilter = !!search || status !== UserOrganizationStatus.ALL

  const handleTabChange = (value: string) => {
    setTab(value)
    navigate({ to: '/admin/bill', search: { tab: value } })
  }

  return (
    <Fragment>
      {/* <div className="flex items-center gap-3 w-full pr-8 sm:absolute sm:right-0 sm:top-4 sm:w-auto">
        {checkCycle?.data?.hasActiveCycle ? <Button
          className="rounded-lg"
          onClick={() => navigate({ to: '/admin/bill/create', search: { tab } })}
        >
          {t('btn_create')}
        </Button> : null}
      </div> */}
      <div className="relative">
        <div className="mb-4 flex gap-4">
          <div className="flex flex-col gap-2">
            <div className="text-sm font-medium">ค้นหา</div>
            <Input
              className="lg:max-w-96"
              placeholder="ค้นหา"
              disabled={isLoading}
              autoComplete="off"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="relative mt-4 p-4 md:p-8">
        <DataTable
          {...dataTableProps}
          isFilter={isHasFilter}
          isLoading={isPending}
        />

      </div>

      {/* <ConfirmInviteModal
          onConfirm={() => handleClickResendInvitation(userSelected)}
          email={userSelected?.email ?? ''}
          isResend={true}
        /> */}
      {/* <InvitedWarningModal /> */}
      {/* <ConfirmDeleteUserModal
          onConfirm={() => handleClickDeleteUser(userSelected)}
          email={userSelected?.email ?? ''}
        /> */}
      {isLoading && <Loader.FullScreen />}
    </Fragment >
  )
}
